import { Fragment } from "react";

function Footer() {
  return (
     <Fragment>
            <footer>
            <p className="pt-3">Coding problem - www.greentrust.in/finding-falcone</p>
            </footer> 
     </Fragment>
  );
}

export default Footer;